import { useQuery } from 'react-query';

import { getTaskDataByHashCode as queryFn } from 'api/endPoints/getTaskDataByHashCode';
import { QueryFnResponse, QueryParams, QueryResponse } from 'api/queries/getTaskDataByHashCode.query';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetTaskDataByHashCodeSearch = (params: QueryParams) => {
    return useQuery<QueryFnResponse[], QueryError, QueryResponse[], [QueryKeys, unknown]>({
        queryKey: ['getTaskDataByHashCodeSearch', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.metaDataId),
        staleTime: 0,
        cacheTime: 0,
    });
};
